
    import Vue from 'vue';
    import Component from "vue-class-component";
    import {
        EndorsementPositionModel, 
        EndorsementRestrictionModel,
        factory,
        PositionOption,
        RestrictionOption
    } from "@/api-client";
    import {BModal} from "bootstrap-vue";
    import {Prop} from "vue-property-decorator";
    import CreateUUID from "@/guid";
    import {isNullOrWhiteSpace} from "@/extensions/string.helpers";
    import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    
    @Component({
        components: {
            HeadingGroup,
            LabelOptional
        },
    })
    export default class EndorsementPositionModal extends Vue{
        private position = factory.create(PositionOption);
        private restrictions: RestrictionOption[] = [];
        private customRestrictions: EndorsementRestrictionModel[] = [];

        @Prop({required: true})
        private positionOptions!: PositionOption[];
        @Prop({required: true})
        private restrictionOptions!: RestrictionOption[];
        
        private onSubmit!: (model: EndorsementPositionModel) => void;
        
        $refs!:{
            modal: BModal;
        }
        
        createUUID(){
            return CreateUUID();
        }
        
        public open(model: EndorsementPositionModel, onSubmit: (model: EndorsementPositionModel) => void){
            this.$refs.modal.show();
            this.onSubmit = onSubmit;
            this.position = this.positionOptions.filter(p => p.value === model.id)[0];
            this.restrictions = model.restrictions.filter(r => !!r.id).map(r => this.restrictionOptions.filter(o => o.value === r.id)[0]);
            this.customRestrictions = model.restrictions.filter(r => !r.id);
        }

        private isSubmitEnabled(){
            return this.position && this.customRestrictions.every(r => !isNullOrWhiteSpace(r.descriptionEst))
        }

        private getRestrictionLabel(restriction: RestrictionOption) {
            return restriction.name.localizedOrDefault;
        }
        
        private submit(){
            if(!this.isSubmitEnabled()) return;    
            let restrictions = this.restrictions.map(r => {
                const restriction = factory.create(EndorsementRestrictionModel);
                restriction.id = r.value;
                return restriction;
            });
            restrictions = restrictions.concat(this.customRestrictions);
            const model = new EndorsementPositionModel({id: this.position.value, restrictions: restrictions});
            this.onSubmit(model);
            this.$refs.modal.hide();
        }
        
        private removeRestriction(restriction: RestrictionOption){
            this.restrictions.splice(this.restrictions.indexOf(restriction), 1);
        }
        
        private addCustomRestriction(){
            this.customRestrictions.push(factory.create(EndorsementRestrictionModel));
        }

        private removeCustomRestriction(restriction: EndorsementRestrictionModel){
            this.customRestrictions.splice(this.customRestrictions.indexOf(restriction), 1);
        }
    }
